
/*为农服务系统*/

/*主容器文件*/
const main = () =>  import("../../../studio/sub_systems/agro_service/agro_service_main");

/*为农服务  首页子系统*/
const main_container = () =>  import("../../../studio/sub_systems/agro_service/index_page/index_page_main");
// 农技方案
const agrotechnicalScheme = () =>  import("../../../studio/sub_systems/agro_service/index_page/agrotechnicalScheme/main");
// 农技视频
const agrotechnicalVideo = () =>  import("../../../studio/sub_systems/agro_service/index_page/agrotechnicalVideo/main.vue");
// 种植管理-地块列表
const massifList = () =>  import("../../../studio/sub_systems/agro_service/index_page/massif/list/index");
// 种植管理-作物管理
const massifCrop = () =>  import("../../../studio/sub_systems/agro_service/index_page/massif/crop/index");
// 种植管理-作物品种
const cropVarietiesForm = () =>  import("../../../studio/sub_systems/agro_service/index_page/massif/crop/cropVarietiesForm");
// 种植管理-生育期管理
const massifBirth = () =>  import("../../../studio/sub_systems/agro_service/index_page/massif/birth/index");
// 种植管理-方案管理
const massifProgramme = () =>  import("../../../studio/sub_systems/agro_service/index_page/massif/programme/index");
// 市场行情
// const marketPrice = () =>  import("../../../studio/sub_systems/policyNews/index_page/marketPrice/index");



export default [
  {
    path: '/agroService',
    name: '资讯发布系统',
    redirect: '/agroService/agrotechnicalScheme/index',
    component: main,
    children: [
      {
        path: '/policyNews/index',
        redirect: '/agroService/agrotechnicalScheme/index',
        name: '首页',
        component: main_container,
        children:[
          {
            path: '/agroService/agrotechnicalScheme/index',
            name: '农技方案',
            component: agrotechnicalScheme ,
          },
          {
            path: '/agroService/agrotechnicalVideo/index',
            name: '农技视频',
            component: agrotechnicalVideo ,
          },
          {
            name: "地块列表",
            path: "/agroService/massif",
            redirect: "/agroService/massif/list",
            component: massifList
          },
          {
            name: "地块列表",
            path: "/agroService/massif/list",
            component: massifList
          },
          {
            name: "作物管理",
            path: "/agroService/massif/crop",
            component: massifCrop,
          },
          {
            name: "作物品种",
            path: "/agroService/massif/crop/cropVarietiesForm",
            component: cropVarietiesForm,
          },
          {
            name: "生育期管理",
            path: "/agroService/massif/birth",
            component: massifBirth
          },
          {
            name: "方案管理",
            path: "/agroService/massif/programme",
            component: massifProgramme
          },
        ]
      },

    ]
  },

]



// WEBPACK FOOTER //
// ./src/router/modules/agroService/agro_service_page.js